// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"src_views_Bridge_Jitsi_vue":"7e5a4a59","src_views_Bridge_index_vue":"4be99e71","src_views_Layout_vue":"e41b4177"}[chunkId] + ".js";
};